import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { ActionReducerMap, StoreModule } from '@ngrx/store';
import { pick } from 'lodash-es';

import { SalesRepState } from './sales-rep-store';
import { SalesRepEffects } from './salesrep/salesrep.effects';
import { salesRep } from './salesrep/salesrep.reducers';

const salesRepReducers: ActionReducerMap<{ salesRep: SalesRepState }> = { salesRep };

const salesRepEffects = [SalesRepEffects];

@NgModule({
  imports: [EffectsModule.forFeature(salesRepEffects), StoreModule.forFeature('salesRep', salesRepReducers)],
})
export class SalesRepStoreModule {
  static forTesting(...reducers: (keyof ActionReducerMap<SalesRepState>)[]) {
    return StoreModule.forFeature('salesRep', pick(salesRepReducers, reducers));
  }
}
